
// @ts-nocheck

export default function rangeTransform(inputRange: number[], outputRange: number[], input: number): number {

    let rangeInterval;

    if(input >= inputRange[inputRange.length-1]) return outputRange[outputRange.length-1];
    if(input <= inputRange[0]) return outputRange[0];

    for(let i = 1; i < inputRange.length; i++) {

        if( input > inputRange[i-1] && input <= inputRange[i] ) {
            
            rangeInterval = [i-1, i] // [start, end]

            break;
        }

    }

    return outputRange[rangeInterval[0]] + ((outputRange[rangeInterval[1]] - outputRange[rangeInterval[0]]) / (inputRange[rangeInterval[1]] - inputRange[rangeInterval[0]])) * (input - inputRange[rangeInterval[0]]);


}